import React from 'react'
import {removeZeros} from '../../../utils/misc'


export default class Discount extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    let item = this.props.item, value=e.target.value

    item['discount_edited'] = value
    // if(value.length === 0) {
    //   item['discount_edited']= 0
    // }
    // else {
    //   item['discount_edited']= parseFloat(value)
    // }
    this.props.onChangeCallback(item)
  }

  render(){
    let item = this.props.item
    let inputValue
    if(typeof item['discount_edited'] !== "undefined") {
      if (isNaN(item['discount_edited'])) {
        inputValue = Number(0)
      }
      else {
          inputValue = removeZeros(item['discount_edited'])
      }
    }
    else {
      inputValue = removeZeros(item['discount_value'])
    }
    return <input type="number" step=".01" className="form-control input-sm" value={inputValue} onChange={this.handleChange} />


  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/discount.js